import type { ChatMessage } from 'livekit-client';

export const ROLES = ['ingest', 'panelist', 'cleanfeed', 'audience', 'metrics'] as const;
export type Role = (typeof ROLES)[number];

/**
 * Controls how the agent handles the context of a previous session on (re)start:
 * - `inherit` (backend default): replay the previous session's context;
 * - `reset`: start fresh; the previous context is archived (never deleted).
 */
export type ContextMode = 'inherit' | 'reset';

export interface SessionPayload {
  role: Role;
  participantName?: string;
  email?: string;
  voiceEnabled?: boolean;
  maxWords?: number;
  contextMode?: ContextMode;
}

export interface SessionResponse {
  token: string;
  roomName: string;
  livekitUrl: string;
  role: Role;
  /** True when a previous session's context is recoverable (meaningful for the ingest role). */
  hasExistingContext: boolean;
}

/** ChatMessage enriched with the sender's participant identity */
export interface ChatEntry {
  message: ChatMessage;
  senderIdentity: string;
  isAgent: boolean;
}
